import React, {useState} from 'react';
import $api, {API_URL} from "../../http";
import ModalDialog from "../ModalDialog";
import ModalImgViewer from "./ModalImgViewer";
import {addDevidersToString, downloadHandler} from "./helper-functions";

const SupportAppealTable = ({appeals, processing, closeAppeal}) => {

    const [activeModal, setActiveModal] = useState("no")
    const [activeModalSupportReaction, setActiveModalSupportReaction] = useState("no")
    const [activeSupportConfirmModal, setActiveSupportConfirmModal] = useState("no")
    const [activeNoPayModal, setActiveNoPayModal] = useState("no")
    const [modalMessage, setModalMessage] = useState("")
    const [activeActionModal, setActiveActionModal] = useState("no")
    const [activeActualAmountModal, setActiveActualAmountModal] = useState("no")

    const [winner, setWinner] = useState()

    const [activeImgModal, setActiveImgModal] = useState("no")
    const [imgSrc, setImgSrc] = useState("")

    const [appealToClose, setAppealToClose] = useState()

    const [progress, setProgress] = useState(0)
    const [loading, setLoading] = useState(false)


    const [currentAppeal, setCurrentAppeal] = useState()

    const noPayment = async (appealId, scam) => {
        const response = await $api.post('/appeal_no_payment', {appealId, scam})

        console.log(response.data)


    }

    return (

        appeals.length
            ?
            // <div className={"transaction-table-wrapper"}>
                <div style={{overflowX: 'auto', width: '100%' }}>
            <table className="transaction-table">
                <thead>
                <tr>
                    <th>Дата</th>
                    <th>Номер</th>
                    <th>Заявка</th>
                    <th>Мерчант</th>
                    <th>Трейдер</th>
                    <th>Сумма (руб)</th>
                    <th>Решение</th>
                    <th>Инфо</th>
                    <th>От Мерчанта</th>
                    <th>Актуальная сумма</th>
                    <th>Чек</th>

                    <th className={"fixed-table-width"}>Управление</th>

                </tr>
                </thead>
                <tbody>
                {appeals.length
                    ?
                    appeals?.map((appeal, index) => {
                    // const formattedDate = new Date(card.block_timestamp)
                    //     .toLocaleString('ru-RU', options);

                    return (
                        <tr
                            key={appeal._id}
                            // className={
                            //     index % 2 === 0
                            //         ?
                            //         'even-row'
                            //         :
                            //         'odd-row'
                            // }
                            className={
                                appeal.status === "pending" && !appeal.traderReaction
                                    ?
                                    "red-row"
                                    :
                                    appeal.status === "pending" && appeal.traderReaction
                                        ?
                                        "green-row"
                                        :
                                        index % 2 === 0
                                            ?
                                            'even-row'
                                            :
                                            'odd-row'

                            }
                        >
                            <td>{new Date(appeal.created_at).toLocaleString([], {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: '2-digit',
                                minute: '2-digit'
                            })}</td>
                            <td>{appeal.number}</td>
                            <td>{appeal.order?.number}</td>
                            <td>{appeal.merchant?.login}</td>
                            <td>{appeal.trader?.login}</td>
                            <td>{appeal.amount}</td>
                            <td>{appeal.resolution}</td>
                            <td>{appeal.traderDescription}</td>
                            <td>{appeal.merchantDescription}</td>
                            <td>{appeal.actualAmount}</td>
                            <td className={"flex-table-cell-column"}>
                                {Array.isArray(appeal.receipt) && appeal.receipt.length > 0 &&
                                    appeal.receipt.map((file, index) => (
                                        <button
                                            key={index}
                                            className="gradient-orange-button show-check-btn"
                                            onClick={async () => {
                                                const lowerFile = file.toLowerCase();
                                                const isPdf = lowerFile.endsWith(".pdf");
                                                const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
                                                const isImage = imageExtensions.some(ext => lowerFile.endsWith(ext));

                                                if (isPdf) {
                                                    const fileUrl = `${API_URL}/${file}`;
                                                    window.open(fileUrl, "_blank");
                                                    return;
                                                }

                                                if (isImage) {
                                                    setActiveImgModal("progress");
                                                    setTimeout(() => {
                                                        setActiveImgModal("active");
                                                    }, 100);
                                                    setImgSrc(file);
                                                    return;
                                                }

                                                // Всё остальное — скачивание
                                                await downloadHandler(file, setLoading, setProgress);
                                            }}
                                        >
                                            {(() => {
                                                const lowerFile = file.toLowerCase();
                                                const isPdf = lowerFile.endsWith(".pdf");
                                                const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
                                                const isImage = imageExtensions.some(ext => lowerFile.endsWith(ext));
                                                const isDownload = !isPdf && !isImage;

                                                if (isDownload) {
                                                    return loading ? `Скачать ${progress}%` : "Скачать";
                                                }

                                                return appeal.receipt.length > 1 ? `Показать ${index + 1}` : "Показать";
                                            })()}
                                        </button>
                                        // <button
                                        //     key={index}
                                        //     className="gradient-orange-button show-check-btn"
                                        //     onClick={() => {
                                        //         console.log(file);
                                        //         if (file.toLowerCase().endsWith(".pdf")) {
                                        //             const fileUrl = `${API_URL}/${file}`;
                                        //             window.open(fileUrl, "_blank");
                                        //             return;
                                        //         }
                                        //         setActiveImgModal("progress");
                                        //         setTimeout(() => {
                                        //             setActiveImgModal("active");
                                        //         }, 100);
                                        //         setImgSrc(file);
                                        //     }}
                                        // >
                                        //     {appeal.receipt.length > 1 ? `Показать ${index + 1}` : "Показать"}
                                        // </button>
                                    ))
                                }
                            </td>

                            <td>
                                {appeal.status !== "closed" && appeal.traderDescription
                                    ?
                                    <button
                                        className={"gradient-orange-button"}
                                        onClick={() => {
                                            setActiveModal("progress")
                                            setTimeout(() => {
                                                setActiveModal("active")
                                            }, 100)
                                            setAppealToClose(appeal)
                                        }}
                                    >
                                        Закрыть
                                    </button>
                                    :
                                    null
                                }
                                {appeal.status !== "closed" && !appeal.traderDescription
                                    ?
                                    <button
                                        className={"gradient-orange-button"}
                                        onClick={() => {

                                            setCurrentAppeal(appeal)
                                            setActiveModalSupportReaction("progress")
                                            setTimeout(() => {
                                                setActiveModalSupportReaction("active")
                                            }, 100)

                                        }}
                                    >
                                        Реакция
                                    </button>
                                    :
                                    null
                                }
                            </td>

                        </tr>
                    );
                    })
                    :
                    null
                }
                </tbody>


            </table>
                <ModalDialog
                    active={activeModal}
                    setActive={setActiveModal}
                    action={() => {
                        setActiveActionModal("progress")
                        setTimeout(() => {
                            setActiveActionModal("active")
                        }, 100)
                    }}
                    message={`Вы подтверждаете закрытие апелляции #${appealToClose?.number}?`}
                    purpose={"choice"}
                />
                <ModalDialog
                    active={activeActionModal}
                    setActive={setActiveActionModal}
                    action={(winner) => {
                        closeAppeal(appealToClose._id, winner)
                    }}
                    action2={() => {
                        setActiveActualAmountModal("progress")
                        setTimeout(() => {
                            setActiveActualAmountModal("active")
                        }, 100)
                    }}
                    message={`В чью пользу закрываем апелляцию #${appealToClose?.number}?`}
                    purpose={"winner"}
                    setWinner={setWinner}
                    setModalMessage={setModalMessage}
                    buttonText1={"Клиент"}
                    buttonText2={"Трейдер"}
                    appealToClose={appealToClose}
                />
                <ModalImgViewer
                    active={activeImgModal}
                    setActive={setActiveImgModal}
                    imgSrc={imgSrc?.replace(/\\/g, "/")}
                    setImgSrc={setImgSrc}
                />

                <ModalDialog
                    active={activeActualAmountModal}
                    setActive={setActiveActualAmountModal}
                    action={() => {

                        closeAppeal(appealToClose._id, winner)
                        // setActiveActionModal("progress")
                        // setTimeout(() => {
                        //     setActiveActionModal("active")
                        // }, 100)
                    }}
                    message={modalMessage}
                    purpose={"choice"}
                />

                    <ModalDialog
                        active={activeModalSupportReaction}
                        setActive={setActiveModalSupportReaction}
                        action={() => {
                            setActiveSupportConfirmModal("progress")
                            setTimeout(() => {
                                setActiveSupportConfirmModal("active")
                            }, 100)
                        }}
                        action2={() => {
                            setActiveNoPayModal("progress")
                            setTimeout(() => {
                                setActiveNoPayModal("active")
                            }, 100)
                        }}
                        message={`Есть платёж на ${addDevidersToString(currentAppeal?.amount)} р. по заявке №${currentAppeal?.order.number} ?`}
                        purpose={"pay_choice"}
                        buttonText2={"Нет"}
                    />

                    <ModalDialog
                        active={activeSupportConfirmModal}
                        setActive={setActiveSupportConfirmModal}
                        action={() => {
                            closeAppeal(currentAppeal._id, "merchant")
                        }}
                        message={`Вы уверены что хотите закрыть апелляцию #${currentAppeal?.number} в пользу клиента?`}
                        purpose={"choice"}

                    />
                    <ModalDialog
                        active={activeNoPayModal}
                        setActive={setActiveNoPayModal}
                        action={() => {
                            noPayment(currentAppeal._id)
                        }}
                        action2={() => {

                            setActiveNoPayModal("progress")
                            setTimeout(() => {
                                setActiveNoPayModal("no")
                            }, 100)

                            setActiveActualAmountModal("progress")
                            setTimeout(() => {
                                setActiveActualAmountModal("active")
                            }, 100)
                        }}
                        action3={() => noPayment(currentAppeal._id, true)}
                        message={`Какой из этих случаев ваш?`}
                        purpose={"no_pay_choice"}

                    />


            </div>
            :
            processing
                ?
                <img src={require('../../img/loading.gif')} height={"40px"}
                     className={"margin-left-20"}/>
                :
                <h2>Нет ничего соответствующего вашему запросу</h2>






    );
};

export default SupportAppealTable;